import Login from "../Auth/Signin";
import VendorSignin from "../Auth/VendorSignin";

export const authRoutes = [
  // { path: `${process.env.PUBLIC_URL}/login`, Component: <Login /> },
  { path: `${process.env.PUBLIC_URL}/login`, Component: <VendorSignin /> },
];
